import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { downloadPdfComplete } from '../model/configuratorSlice';
import SaveConfigurationService from './SaveConfigurationService';
import { EndPoints, Language } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';


export default function DownloadPdfService() {
  const {
 promotionSlug, settings, currentUnit, currentLanguage, isPublic,
} = useSelector(state => state.configurator);
  const saveConfigurationMutation = SaveConfigurationService();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const callback = (code) => {
    const unitId = currentUnit !== null ? currentUnit.id : 0;
    let downloadPdfUrl = isPublic
        ? `${EndPoints.PublicDownloadPdf}/${promotionSlug}/code/${code}/download-pdf`
        : `${EndPoints.DownloadPdf}/${promotionSlug}/unit/${unitId}/code/${code}/download-pdf`;
    if (currentLanguage !== Language.es) {
        downloadPdfUrl = `${downloadPdfUrl}?language=${currentLanguage}`;
    }

    const fileName = `${settings.name}_${code}.pdf`;
    const config = {
      headers: {
        [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
      },
      responseType: 'blob',
    };
    axios
        .post(downloadPdfUrl, {}, config)
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            /*
            // window.open(URL.createObjectURL(response.data), isMobile ? '_self' : '_blank', 'noopener,noreferrer');
          navigate(`/${promotionSlug}/${code}`);
          window.open(URL.createObjectURL(response.data), '_self', 'noopener,noreferrer');

           */
          dispatch(downloadPdfComplete());
        })
        .catch((error) => {
          console.log(error);
          // dispatch(setSnackbarMessage(SnackbarMessages.ConfigurationCodeNotFound));
        });
  };

  return useMutation(['downloadPdfQuery'], () => {
    saveConfigurationMutation.mutate(callback);
  });
}
